import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import { eventBus } from '@/utils/eventBus';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Beranda', href: '#home' },
    { name: 'Layanan', href: '#services' },
    { name: 'Keunggulan', href: '#keunggulan' },
    { name: 'Galeri', href: '#gallery' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-700 ${
      isScrolled ? 'bg-white/95 backdrop-blur-xl shadow-sm py-3' : 'bg-transparent py-6'
    }`}>
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        <a href="#home" onClick={(e) => scrollToSection(e, '#home')} className="flex items-center group z-50">
          <img 
            src="/images/logo_sueti_fix.png" 
            alt="Sueti Tour Logo" 
            className={`h-10 md:h-12 w-auto transition-all duration-500 ${!isScrolled && 'brightness-0 invert drop-shadow-md'}`} 
            onError={(e) => { e.target.src = "https://placehold.co/150x50/0171c3/white?text=Sueti+Tour"; }}
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          <ul className="flex gap-8">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a 
                  href={link.href} 
                  onClick={(e) => scrollToSection(e, link.href)} 
                  className={`text-sm font-medium tracking-widest uppercase transition-colors relative group ${
                    isScrolled ? 'text-gray-600 hover:text-primary' : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.name}
                  <span className={`absolute -bottom-2 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full ${
                    isScrolled ? 'bg-accent' : 'bg-white'
                  }`}></span>
                </a>
              </li>
            ))}
          </ul>
          <button 
            onClick={(e) => { e.preventDefault(); eventBus.dispatch('openBookingModal'); }}
            className={`px-8 py-3.5 rounded-sm font-medium text-sm tracking-widest uppercase transition-all duration-300 flex items-center gap-2 cursor-pointer ${
              isScrolled 
                ? 'bg-primary text-white hover:bg-primary-dark shadow-lg shadow-primary/20' 
                : 'bg-white text-primary hover:bg-white/90 shadow-xl'
            }`}
          >
            Konsultasi
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className={`md:hidden p-2 focus:outline-none z-50 ${isScrolled || isMobileMenuOpen ? 'text-gray-900' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <SafeIcon name={isMobileMenuOpen ? "X" : "Menu"} className="w-8 h-8" />
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-0 left-0 w-full h-screen bg-white md:hidden flex flex-col pt-24 px-8"
          >
            <div className="flex flex-col gap-6 items-center text-center">
              {navLinks.map((link) => (
                <a key={link.name} href={link.href} onClick={(e) => scrollToSection(e, link.href)} className="text-gray-900 font-serif text-2xl py-2 hover:text-accent transition-colors">
                  {link.name}
                </a>
              ))}
              <div className="w-12 h-px bg-gray-200 my-4"></div>
              <button 
                onClick={() => eventBus.dispatch('openBookingModal')} 
                className="bg-primary text-white px-8 py-4 rounded-sm font-medium tracking-widest uppercase text-sm w-full shadow-lg"
              >
                Hubungi Kami Sekarang
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;